import  React, {useEffect} from "react";
import { useState, useContext } from "react";
import { makeStyles, Theme, createStyles } from "@mui/styles";
import * as request from "superagent";
import { Grid, Typography } from "@mui/material";
import EmptySet from "~common/components/empty-set";
import Renderers from "~common/lib/renderers";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      marginTop: theme.spacing(2),
      marginRight: 10,
	  width: "100%"
    },
	dataRow: {
		marginLeft: 20,
		marginRight: 20,
		width: "100%",
		display: "flex",
		justifyContent: "center",
		textDecoration: "none",
	},
	category: {
	  marginRight: 40,
	  width: "60%",
	  fontSize: 20,
	  fontWeight: 600,
	  color: theme.palette.primary.main
	},
	count: {
	  width: "40%",
	  fontSize: 24,
	  fontWeight: 600,
	  color: theme.palette.secondary.main
	}
  })
);

export interface HudeDashboardCardRendererProps {
	data: any;
	element: any;
	metrics: any;
}

export const HudeDashboardCardRenderer: React.FC<HudeDashboardCardRendererProps> = ({
	data
}) => {
    const classes = useStyles();    

	const getResultsGridList = () => {

		let gridItems:Array<any> = []

		for(let i = 0; i < data.length; i++) {
			var q =  btoa(JSON.stringify({"docTypeCategory":data[i].category,"limit":10}));
			gridItems.push(
				<Grid key={data[i].category} item sm={12} md={12} lg={12} xl={12}>
					<a className={classes.dataRow} href={"/payables/invoice-processing/hude?q=" + q}>
							<Typography className={classes.category}>
								{data[i].category}
							</Typography>
							<Typography className={classes.count}>
								{data[i].taskCount}
							</Typography>
					</a>
				</Grid>
			)


		}

		return gridItems;

	}

	const gridItems = getResultsGridList();

	return (
		<div className={classes.container}>
			<Grid container>
				{gridItems}
			</Grid>
		</div>
		);
	};

HudeDashboardCardRenderer.register = () => {
    if (!Renderers.find("HudeDashboardCardRenderer")) {
        Renderers.register("HudeDashboardCardRenderer", HudeDashboardCardRenderer);
    }
}

export default HudeDashboardCardRenderer;
